import { PhotoGridPositionsEnum, UserAccountStatusEnum } from '@/lib/enum.ts';
import PhotoVerificationGroupFooter from './PhotoVerificationGroupFooter';
import PhotoVerificationGroupHeader from './PhotoVerificationGroupHeader';
import PhotoVerificationGroupInfos from './PhotoVerificationGroupInfos';
import BannerAdditionalCheckInfo from '../BannerAdditionalCheckInfo';
import { IUserPicture, IVerifications } from '@/lib/interface.ts';
import { UserProfileDetailsInfos } from '../userProfileDetails';
import BadgeUserAccountStatus from '../BadgeUserAccountStatus';
import { Separator } from '@/components/ui/separator.tsx';
import { Card } from '@/components/ui/card.tsx';
import UserPhotoGrid from '../userPhotoGrid';

interface TProps {
	item: IVerifications;
	onClickAcceptDenyBtn?: (
		accept: boolean,
		userId: string,
		position: PhotoGridPositionsEnum,
	) => void;
	readonly?: boolean;
	deniedStateChange?: boolean;
	onClickDeletePictureBtn?: (userId: string, picture: IUserPicture) => void;
	onClickAcceptDenyAllBtn?: (acceptAll: boolean, userId: string) => void;
	disableActionInvalidations?: boolean;
	removeItemLocally?: (userId: string) => void;
}

const PhotoVerificationGroup = ({
	item,
	readonly,
	deniedStateChange,
	onClickAcceptDenyBtn,
	onClickDeletePictureBtn,
	onClickAcceptDenyAllBtn,
	disableActionInvalidations,
	removeItemLocally
}: TProps) => (
	<Card className='animate__animated animate__fadeIn relative'>
		<div className='flex flex-col space-y-4'>
			<div className='flex flex-col'>
				<PhotoVerificationGroupHeader
					user={item.userData as any}
					disableActionInvalidations={disableActionInvalidations}
					removeItemLocally={removeItemLocally} />
				<BannerAdditionalCheckInfo
					className='border-b'
					additionalCheck={item.additionalCheck} />
			</div>
			<div className={'flex flex-col space-y-4 justify-center px-2 md:px-4'}>
				<UserPhotoGrid
					readonly={readonly}
					userData={item.userData}
					onClickAcceptDenyBtn={onClickAcceptDenyBtn}
					onClickDeletePictureBtn={onClickDeletePictureBtn} />
				<div className='flex flex-col space-y-1'>
					<UserProfileDetailsInfos
						hideCountry
						hideCoins
						hideEmail
						hideAge
						align='center'
						userData={item.userData as any}
						className='justify-center mx-auto' />
					<PhotoVerificationGroupInfos
						createdAt={item.createdAt}
						updatedAt={item.updatedAt}
						readonly={readonly} />
				</div>
			</div>
			<Separator />
			{
				!readonly &&
				onClickAcceptDenyAllBtn &&
				<PhotoVerificationGroupFooter
					onClickAcceptDenyAllBtn={onClickAcceptDenyAllBtn}
					deniedStateChange={deniedStateChange}
					userId={item.userData?._id}
					verificationId={item._id} />
			}
		</div>
		<BadgeUserAccountStatus
			user={item.userData}
			title='Cet utilisateur est inactif'
			isVisible={l => l.accountStatus !== UserAccountStatusEnum.ACTIVE}
			className={'text-nowrap px-2 py-0.5 text-xs rounded-sm absolute -top-2 -right-1'} />
	</Card>
);

export default PhotoVerificationGroup;
